const HelpCenter = requireAuth => [
  {
    path: '/help-center',
    name: 'HelpCenter',
    component: () => import('./views/HelpCenter'),
    beforeEnter: requireAuth
  }
]

export default HelpCenter



// WEBPACK FOOTER //
// ./src/modules/helpCenter/routes.js